mutation homeNumberArchive($id: ID!) {
  homeNumberArchive(id: $id) {
    id
  }
}
